<template>
  <div >
    <!-- <h1 class="filter-header">Template</h1> -->
    <div class="widget-settings-container">
      <div class="side-menu">
        <div class="items-wrapper">
          <el-form v-model="form" >
            <div class="controllable-box" >
              <h3>Widget Details</h3>
              <el-row>
                <el-form-item label="Widget Name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="Widget Description">
                  <el-input type="textarea" v-model="form.description"></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="CTA (optional)">
                  <el-input type="textarea" v-model="form.searchTitle"></el-input>
                </el-form-item>
              </el-row>
              <el-row>
              <el-form-item >
                <el-checkbox
                  class="d-flex flex-align-items-center"
                  v-model="form.isActive"
                  label="Enabled"
                  border
                  active-color="#13ce66"
                  inactive-color="#ff4949"></el-checkbox>
              </el-form-item>
            </el-row>
            </div>
            <!-- <el-row>
              <el-form-item label="Widget Type">
                <el-select v-model="form.widgetType" placeholder="Select a type">
                  <el-option label="Fixtures" value="fixture"></el-option>
                  <el-option label="LadderBoards" value="ladderboard"></el-option>
                </el-select>
              </el-form-item>
            </el-row> -->
            <div class="controllable-box" v-if="form.widgetType !== 'calendar' && form.widgetType !== 'clubFinder'">
              <h3>Filter Competitions</h3>
              <div class="description" >Manage which competitions will be available in the widget.</div>
              <el-row>
                <el-form-item>
                  <el-select v-model="form.widgetSettings.competitionList" value-key="_id" placeholder="Select competitions" multiple filterable>
                    <el-option v-for="{name,_id,isActive} in competitions" :key="_id" :label="name" :value="{name,_id,isActive}">
                      <span style="float: left">{{ name }}</span>
                      <span style="float: right">
                          <el-tag effect="plain" :type="isActive? 'success': 'danger'">
                          {{ isActive? 'Active': 'Inactive' }}</el-tag>
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-row>
            </div>
            <div class="controllable-box" v-else-if="form.widgetType === 'calendar'">
              <h3>Filter Entity</h3>
              <div class="description" >Manage which entity will be available in the widget.</div>
              <el-row :gutter="15">
                <el-col>
                  <div>
                    <el-select placeholder="Select Entity" size="large"  value-key="_id" v-model="form.widgetSettings.calendarEntity.entity" multiple>
                      <el-option v-for="option in entities" :key="option.value" :value="option.value" :label="option.label"></el-option>
                    </el-select>
                  </div>
                  <el-row>
                    <el-form v-model="form.widgetSettings">
                      <el-form-item label="Memberships" v-if="form.widgetSettings.calendarEntity.entity && form.widgetSettings.calendarEntity.entity.includes('membership')">
                        <el-select v-model="form.widgetSettings.calendarEntity.eventEntityIds" value-key="_id" placeholder="Select Membership" multiple filterable >
                          <el-option v-for="{name,_id} in memberships" :key="_id" :label="name" :value="{_id, name, entity: 'membership'}"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="Events" v-if="form.widgetSettings.calendarEntity.entity && form.widgetSettings.calendarEntity.entity.includes('event')">
                        <el-select v-model="form.widgetSettings.calendarEntity.membershipEntityIds" value-key="_id" placeholder="Select Event" multiple filterable >
                          <el-option v-for="{name,_id} in events" :key="_id" :label="name" :value="{_id, name, entity: 'event'}"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </el-row>
                </el-col>
                </el-row>
            </div>
            <div class="controllable-box" v-if="form.widgetType === 'clubFinder'">
              <h3>Exclude Clubs</h3>
              <div class="description" >Select clubs to exclude from the widget.</div>
              <el-row>
                <el-form-item>
                  <el-select v-model="form.widgetSettings.clubExcludeList" value-key="_id" placeholder="Select clubs" multiple filterable>
                    <el-option v-for="{name,_id,isActive} in clubs" :key="_id" :label="name" :value="{name,_id,isActive}">
                      <span style="float: left">{{ name }}</span>
                      <span style="float: right">
                          <el-tag effect="plain" :type="isActive? 'success': 'danger'">
                          {{ isActive? 'Active': 'Inactive' }}</el-tag>
                      </span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-row>
            </div>
            <div class="controllable-box" v-if="form.widgetType === 'calendar'">
              <h3>Select Year</h3>
              <div class="description" >Manage which calendar year will be available in the widget.</div>
              <el-row :gutter="15">
                <el-form v-model="form.widgetSettings">
                  <el-col :span="24">
                    <el-form-item prop="season">
                      <el-select v-model="form.widgetSettings.calendarEntity.season" style="width: 100%">
                        <el-option
                          v-for="s in seasons"
                          :key="s.value"
                          :label="s.value"
                          :value="s.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-row>
            </div>
            <div class="controllable-box" v-if="form.widgetType === 'calendar'">
              <h3>Select Month</h3>
              <div class="description" >Manage which calendar month will be available in the widget.</div>
              <el-row :gutter="15">
                <el-form v-model="form.widgetSettings">
                  <el-col :span="24">
                    <el-form-item prop="month">
                      <el-select v-model="form.widgetSettings.calendarEntity.month" style="width: 100%">
                        <el-option
                          v-for="s in months"
                          :key="s.value"
                          :label="s.label"
                          :value="s.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-row>
            </div>
            <div class="controllable-box">
              <h3>Breakpoints</h3>
              <div class="description" >You may add a maximum width or height to the widget. The maximum width is : 1280px. If custom width less than or equal to 768px, mobile layout will be rendered</div>
              <el-row>
                <el-form-item>
                  <el-checkbox
                    @change="hasCustomWidthChange"
                    class="d-flex flex-align-items-center"
                    v-model="form.widgetSettings.hasCustomWidth"
                    label="Enable Custom Width"
                    border
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-checkbox>
                </el-form-item>
                 <el-form-item v-if="form.widgetSettings.hasCustomWidth">
                  <el-input  @change="handleMaxWidthChange" v-model="form.widgetSettings.customWidth" placeholder="Enter maximum width">
                    <template slot="append">px</template>
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-checkbox
                    class="d-flex flex-align-items-center"
                    v-model="form.widgetSettings.hasCustomHeight"
                    label="Enable Custom Height"
                    border
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-checkbox>
                </el-form-item>
                <el-form-item v-if="form.widgetSettings.hasCustomHeight">
                  <el-input :controls="false" @change="handleHeightChange" v-model="form.widgetSettings.customHeight" placeholder="Enter maximum height">
                    <template slot="append">px</template>
                  </el-input>
                </el-form-item>
              </el-row>
            </div>
            <div class="controllable-box" v-if="form.widgetType !== 'calendar' && form.widgetType !== 'clubFinder'">
              <h3>Visible Fields</h3>
              <div class="description" >Manage what fields are visible on your fixture widget</div>
              <el-row>
                <el-form-item >
                  <el-checkbox
                    class="d-flex flex-align-items-center"
                    v-model="form.widgetSettings.showTeamCrest"
                    label="Show Team Crest"
                    border
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-checkbox>
                </el-form-item>
              </el-row>
              <el-row v-if="form.widgetType === 'fixture'">
                <el-form-item >
                  <el-checkbox
                    class="d-flex flex-align-items-center"
                    v-model="form.widgetSettings.showVenue"
                    label="Show Venue"
                    border
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-checkbox>
                </el-form-item>
              </el-row>
              <el-row v-if="form.widgetType === 'fixture'">
                <el-form-item >
                  <el-checkbox
                    class="d-flex flex-align-items-center"
                    v-model="form.widgetSettings.showFields"
                    label="Show Fields"
                    border
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-checkbox>
                </el-form-item>
              </el-row>
              <el-row v-if="form.widgetType === 'fixture'">
                <el-form-item >
                  <el-checkbox
                    class="d-flex flex-align-items-center"
                    v-model="form.widgetSettings.showReferee"
                    label="Show Referees"
                    border
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-checkbox>
                </el-form-item>
              </el-row>
              <el-row v-if="form.widgetType === 'fixture'">
                <el-form-item >
                  <el-checkbox
                    class="d-flex flex-align-items-center"
                    v-model="form.widgetSettings.startOnCurrentDate"
                    label="Start On Current Date"
                    border
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-checkbox>
                </el-form-item>
              </el-row>
              <el-row v-if="form.widgetType === 'fixture'">
                <el-form-item >
                  <el-checkbox
                    class="d-flex flex-align-items-center"
                    v-model="form.widgetSettings.showDate"
                    @change="showDateChange"
                    label="Show Date"
                    border
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-checkbox>
                </el-form-item>
              </el-row>
              <el-row v-if="form.widgetType === 'fixture'">
                <el-form-item v-if="form.widgetSettings.showDate">
                  <el-checkbox
                    class="d-flex flex-align-items-center"
                    v-model="form.widgetSettings.showDay"
                    label="Show Day"
                    border
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-checkbox>
                </el-form-item>
              </el-row>
              <el-row v-if="form.widgetType === 'ladderboard'">
                <el-form-item >
                  <el-checkbox
                    class="d-flex flex-align-items-center"
                    v-model="form.widgetSettings.showBonusPoints"
                    label="Show Bonus Points"
                    border
                    active-color="#13ce66"
                    inactive-color="#ff4949"></el-checkbox>
                </el-form-item>
              </el-row>
            </div>
            <div class="controllable-box" v-if="form.widgetType !== 'calendar' && form.widgetType !== 'clubFinder'">
              <h3>Time Format</h3>
              <div class="description" >Choose the time format for your fixture widget</div>
              <el-row>
                <el-form-item class="d-flex flex-align-items-center">
                  <el-radio-group class="d-flex flex-align-items-center" v-model="form.widgetSettings.timeOption">
                    <el-radio-button class="d-flex flex-align-items-center" label="12hrs"></el-radio-button>
                    <el-radio-button class="d-flex flex-align-items-center" label="24hrs"></el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-row>
            </div>
            <div class="controllable-box" v-if="form.widgetType !== 'calendar' && form.widgetType !== 'clubFinder'">
              <h3>Team Name Format</h3>
              <div class="description" >Choose the team name format for your fixture widget</div>
              <el-row>
                <el-form-item class="d-flex flex-align-items-center">
                  <el-select v-model="form.widgetSettings.teamNameFormat" >
                    <el-option label="Team Name" value="teamName"></el-option>
                    <el-option label="Team Short Name" value="teamShortName"></el-option>
                    <el-option label="Team Abbreviation" value="teamAbbreviation" ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
            </div>
            <!-- <el-row>
              <el-form-item >
                <el-checkbox
                  class="d-flex flex-align-items-center"
                  v-model="form.widgetSettings.hasCustomBreakpoints"
                  border
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                  Has Custom Breakpoints
                  <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">Manage the mode displayed at each breakpoint. If no breakpoints are added, the widget will follow the default responsive guidelines </div>
                    <i class="el-icon-info info"/>
                  </el-tooltip>
                  </el-checkbox>
              </el-form-item>
            </el-row> -->
            <!-- <div>
              <el-row v-if="form.widgetSettings.hasCustomBreakpoints">
                <el-form-item label="Custom Breakpoints">
                  <el-input v-model="form.widgetSettings.customBreakpoints.width" placeholder="Width: 500px"></el-input>
                  <el-input class="mt-2" v-model="form.widgetSettings.customBreakpoints.height" placeholder="Height: 500px"></el-input>
                </el-form-item>
              </el-row>
            </div> -->

          </el-form>
        </div>
      </div>
      <div class="editor">
        <div class="editor-section">
          <div class="editor-header d-flex  flex-align-items-center gap-05 flex-justify-space-between ">
            <div class="d-flex flex-column">
              <h3 class="filter-header text-highlight">Preview</h3>
              <small class="gray-text f-light">How the widget will show up on your website</small>
            </div>
            <el-radio-group v-model="breakpoint" size="large">
              <el-radio-button label="mobile" ><fa-icon :icon="['fal', 'mobile-notch']"/></el-radio-button>
              <el-radio-button :label="form.widgetSettings.hasCustomWidth ? `${form.widgetSettings.customWidth < 600 ? 'mobile-custom': 'desktop'}`: 'desktop'" ><fa-icon :icon="['fal', 'desktop']"/></el-radio-button>
            </el-radio-group>
          </div>
          <div class="widget-preview-container " :style="getPreviewStyle">
            <ladder-widget class="widget-preview" v-if="form.widgetType === 'ladderboard'&& form.widgetSettings.competitionList.length" :breakpoint="breakpoint"  :widget="form" :key="key" />
            <fixtures-widget class="widget-preview" v-if="form.widgetType === 'fixture'&& form.widgetSettings.competitionList.length" :breakpoint="breakpoint"  :widget="form"  :key="key" />
            <calendar-widget class="widget-preview" v-if="form && form.widgetType === 'calendar'" :breakpoint="breakpoint" :eIds="form.widgetSettings.calendarEntity.entityIds" :widget="form" :key="key" :season="form.widgetSettings.calendarEntity.season"/>
            <club-finder-widget class="widget-preview" v-if="form && form.widgetType === 'clubFinder'" :breakpoint="breakpoint" :widget="form" :key="key" />
          </div>

        </div>

        <div class="installation-guide-box mt-2">
          <h3 class="text-highlight">Installation Guide</h3>
          <div class="description" v-if="$route.params.id">{{ `Copy and paste the code below into your index.html file to display the widget`}}</div>
          <div class="description" v-if="!$route.params.id">{{ `Please create your widget first`}}</div>
          <el-row v-if="$route.params.id">
            <h3 class="mt-1">Header</h3>
              <el-input
                class="installation-guide"
                v-model="installationGuide.header"
                type="text"
                :rows="2"
                :autosize="{ minRows: 2, maxRows: 2 }"
                readonly
                disabled
                >
                <template slot="append">
                  <el-button v-clipboard="installationGuide.header" @click="$message.success('Successfully copied to clipboard')">Copy</el-button>
                </template>
              </el-input>
          </el-row>
          <el-row v-if="$route.params.id">
            <h3 class="mt-1">Body</h3>
              <el-input
                class="installation-guide"
                v-model="installationGuide.body.line1"
                type="text"
                :rows="3"
                :autosize="{ minRows: 3, maxRows: 3 }"
                readonly
                disabled>
                <template slot="append">
                  <el-button v-clipboard="installationGuide.body.line1" @click="$message.success('Successfully copied to clipboard')">Copy</el-button>
                </template>
              </el-input>
              <el-input
                class="installation-guide mt-2"
                v-model="installationGuide.body.line2"
                type="text"
                :rows="3"
                :autosize="{ minRows: 3, maxRows: 3 }"
                readonly
                disabled
                >
                <template slot="append">
                  <el-button v-clipboard="installationGuide.body.line2" @click="$message.success('Successfully copied to clipboard')">Copy</el-button>
                </template>
              </el-input>
          </el-row>
        </div>
          <p class="footer">Copyright 2025 Assemble Sports | All Rights Reserved</p>
      </div>
      <div class="footer-action-button action-buttons mt-1">
        <el-button @click="handleBackButton">Go Back</el-button>
        <el-button type="primary" v-if="isInsert" @click="submit" >Create</el-button>
        <el-button type="primary" v-if="!isInsert" @click="edit" icon="el-icon-check">Save</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import { fileUploadAcceptString } from '@/utils/constants';
import ladderWidget from './components/ladderWidget.vue';
import fixturesWidget from './components/fixturesWidget.vue';
import calendarWidget from './components/calendarWidget.vue';
import ClubFinderWidget from './components/ClubFinderWidget.vue';

export default {
  components: {
    ladderWidget,
    fixturesWidget,
    calendarWidget,
    ClubFinderWidget,
  },

  data() {
    const {
      competitionId,
      filters
    } = this.$store.state.matches;
    return {
      centerDialogVisible: false,
      key: 0,
      capitalize: _.capitalize,
      fileUploadAcceptString,
      competitions: [],
      competitionId,
      dayLimitOptions: [
        {
          label: 'Next Day',
          value: 1
        },
        {
          label: 'Next 2 Days',
          value: 2
        },
        {
          label: 'Next 3 Days',
          value: 3
        },
        {
          label: 'Next 4 Days',
          value: 4
        },
        {
          label: 'Next 5 Days',
          value: 5
        },
        {
          label: 'Next 6 Days',
          value: 6
        },
        {
          label: 'Next 7 Days',
          value: 7
        },
        {
          label: 'Next 8 Days',
          value: 8
        },
        {
          label: 'Next 9 Days',
          value: 9
        },
        {
          label: 'Next 10 Days',
          value: 10
        },
      ],

      filters,
      popperVisible: false,
      breakpoint: 'desktop',
      memberships: [],
      events: [],
      clubs: [],
      seasons: this.$store.getters['season/seasons'],
      months: [
        {
          label: 'All',
          value: undefined
        },
        {
          label: 'January',
          value: '0'
        },
        {
          label: 'February',
          value: '1'
        },
        {
          label: 'March',
          value: '2'
        },
        {
          label: 'April',
          value: '3'
        },
        {
          label: 'May',
          value: '4'
        },
        {
          label: 'June',
          value: '5'
        },
        {
          label: 'July',
          value: '6'
        },
        {
          label: 'August',
          value: '7'
        },
        {
          label: 'September',
          value: '8'
        },
        {
          label: 'October',
          value: '9'
        },
        {
          label: 'November',
          value: '10'
        },
        {
          label: 'December',
          value: '11'
        }
      ],
      showWarning: false,
      form: {
        name: undefined,
        description: undefined,
        searchTitle: undefined,
        isActive: true,
        widgetType: undefined,
        widgetSettings: {
          showCurrent: true,
          showBonusPoints: true,
          numberOfFixtures: 10,
          competitionList: [],
          clubExcludeList: [],
          showTeamCrest: true,
          hasCustomWidth: false,
          customWidth: 1280,
          hasCustomHeight: false,
          customHeight: 800,
          showTeamFilter: true,
          showVenue: true,
          showReferee: true,
          showFields: true,
          showLive: false,
          dayLimit: 7,
          startOnCurrentDate: false,
          timeOption: '12hrs',
          showDay: true,
          showDate: true,
          teamNameFormat: 'teamName',
          calendarEntity: {
            eventEntityIds: [],
            membershipEntityIds: [],
            entity: undefined,
            season: this.currentSeason,
            month: undefined,
          },
        },

      },
      activeStatuses: [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false }
      ],
      currentLadder: undefined,
      previewCompId: undefined,
      ladderTemplate: undefined,
      isInsert: false,
      installationGuide: {
        header: '',
        body: {
          line1: '',
          line2: ''
        }
      },
    };
  },
  async mounted() {
    this.$store.commit('app/alwaysCloseSidebar');
    this.fetchEntities();
    const { id, type, isInsert } = this.$route.params;
    this.installationGuide.header = '<link href="https://assemble-fixtures-widgets.s3.ap-southeast-2.amazonaws.com/css/app.css" rel="stylesheet"/> ';
    const scriptTag = document.createElement('script');
    const widgetTag = document.createElement('as-widget');
    widgetTag.setAttribute('widget_id', id);
    widgetTag.setAttribute('national_id', `${process.env.VUE_APP_NATIONAL_ID}`);
    scriptTag.src = 'https://assemble-fixtures-widgets.s3.ap-southeast-2.amazonaws.com/js/app.js';
    this.installationGuide.body.line1 = widgetTag.outerHTML;
    this.installationGuide.body.line2 = scriptTag.outerHTML;
    this.isInsert = isInsert;
    if (id) {
      await this.getWidget(id);
    }
    if (type) {
      this.form.widgetType = type;
    }
    this.previewCompId = 300783;
    this.fetchCompetitions();
    if (this.form.widgetType === 'clubFinder') {
      this.fetchClubs();
    }
    this.showWarning = false;
  },

  computed: {
    nationalLogoAccount() {
      // eslint-disable-next-line global-require
      return process.env.VUE_APP_LOGO_ACCOUNT
          && process.env.VUE_APP_LOGO_ACCOUNT !== ''
        ? process.env.VUE_APP_LOGO_ACCOUNT
        : require('@/assets/logos/Assemble_Logo_RGB_Positive.png');
    },
    getPreviewStyle() {
      // this.form.widgetSettings.hasCustomHeight
      //   ? return `max-width:${this.breakpoint === 'mobile' ? '400' : this.form.widgetSettings.hasCustomWidth ? this.form.widgetSettings.customWidth : '1280'}px; height:${this.form.widgetSettings.customHeight}px`
      //   : return `max-width:${this.breakpoint === 'mobile' ? '450px' : '1280px'}`;
      if (this.form.widgetSettings.hasCustomHeight) {
        if (this.breakpoint === 'mobile') {
          return `max-width:400px; height:${this.form.widgetSettings.customHeight}px`;
        }
        if (this.form.widgetSettings.hasCustomWidth) {
          return `max-width:${this.form.widgetSettings.customWidth}px; height:${this.form.widgetSettings.customHeight}px`;
        }
        return `max-width:1280px; height:${this.form.widgetSettings.customHeight}px`;
      }
      if (this.form && this.form.widgetSettings && this.form.widgetSettings.hasCustomWidth) {
        if (this.breakpoint === 'mobile') {
          return 'max-width:400px; height:800px';
        }
        return `max-width:${this.form.widgetSettings.customWidth}px; height:800px`;
      }
      if (this.breakpoint === 'mobile') {
        return 'max-width:400px; height:800px';
      }
      return 'max-width:1280px; height:800px';
    },
    entities() {
      const entityList = [
        { label: 'Memberships', value: 'membership', module: 'memberships' },
        { label: 'Events', value: 'event', module: 'events' }
      ];
      const entities = [];
      entityList.forEach((entity) => {
        if (this.hasModule(entity.module)) {
          entities.push({
            label: entity.label, value: entity.value
          });
        }
      });

      return entities;
    },
    currentSeason() {
      return this.$store.getters['season/currentSeason'];
    },
    entityIds() {
      const eventIds = _.get(this, 'form.widgetSettings.calendarEntity.eventEntityIds', []);
      const membershipIds = _.get(this, 'form.widgetSettings.calendarEntity.membershipEntityIds', []);
      return { eventIds, membershipIds };
    }
  },
  methods: {
    handleMaxWidthChange(val) {
      this.form.widgetSettings.customWidth = +val;
      if (this.form.widgetSettings.customWidth > 1280) {
        this.form.widgetSettings.customWidth = 1280;
      }
      if (this.form.widgetSettings.customWidth < 900 && this.form.widgetSettings.customWidth > 768) {
        this.form.widgetSettings.teamNameFormat = 'teamShortName';
      }
      if (this.form.widgetSettings.customWidth < 768 && this.form.widgetSettings.customWidth > 600) {
        this.form.widgetSettings.teamNameFormat = 'teamShortName';
        this.form.widgetSettings.showTeamCrest = false;
        this.form.widgetSettings.showReferee = false;
      }
      this.breakpoint = `${this.form.widgetSettings.customWidth < 600 ? 'mobile-custom' : 'desktop'}`;
    },
    handleHeightChange(val) {
      this.form.widgetSettings.customHeight = +val;
    },
    hasCustomWidthChange(val) {
      if (val) {
        // this.form.widgetSettings.customWidth = 1280;
        this.breakpoint = `${this.form.widgetSettings.customWidth < 600 ? 'mobile-custom' : 'desktop'}`;
      } else {
        this.form.widgetSettings.customWidth = 1280;
        this.breakpoint = 'desktop';
      }
    },
    handleBackButton() {
      if (this.showWarning) {
        this.$confirm('Are you sure you want to leave this page? Any unsaved changes will be lost.', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          this.$router.push({ name: 'widgets.list' });
        }).catch(() => {
        // do nothing
        });
      } else this.$router.push({ name: 'widgets.list' });
    },
    showDateChange() {
      if (!this.form.widgetSettings.showDate) {
        this.form.widgetSettings.showDay = false;
      }
    },
    async getWidget(id) {
      try {
        this.$store.commit('loading', true);
        const resWidget = await this.$http.get(`/assemble/api/v1/admin/widget/${id}`);
        this.form = _.assign(this.form, resWidget.data.data);
        if (this.form.widgetSettings.hasCustomWidth && this.form.widgetSettings.customWidth) {
          this.breakpoint = `${this.form.widgetSettings.customWidth < 600 ? 'mobile-custom' : 'desktop'}`;
        }
        this.$store.commit('loading', false);
      } catch (error) {
        this.$store.commit('loading', false);
        this.$message.error(error.response.data.message);
      }
    },
    submit() {
      this.$store.commit('loading', true);
      this.$http.post('/assemble/api/v1/admin/widget', this.form)
        .then((response) => {
          this.$router.push({ name: 'widgets.details', params: { id: response.data.data._id } });
          this.$store.commit('loading', false);
        }).catch((error) => {
          this.$store.commit('loading', false);
          this.$message.error(error.response.data.message);
        });
    },
    edit() {
      if (!this.isInsert) {
        this.$store.commit('loading', true);
        this.$http.put(`/assemble/api/v1/admin/widget/${this.form._id}`, this.form)
          .then(() => {
            this.$store.commit('loading', false);
            this.$message.success('Widget updated successfully');
            this.showWarning = false;
          }).catch((error) => {
            this.$store.commit('loading', false);
            this.$message.error(error.response.data.message);
          });
      }
    },
    fetchCompetitions() {
      this.$store.commit('loading', true);
      this.$http.get('/assemble/api/v1/admin/competitions', {
        params:
        {
          season: this.filters.season,
          isWidget: true,
        }
      })
        .then((response) => {
          this.competitions = response.data.data;
          this.$store.commit('loading', false);
        }).catch((error) => {
          this.$store.commit('loading', false);
          // this.$message.error(error.response.data.message);
        });
    },
    fetchClubs() {
      this.$store.commit('loading', true);
      this.$http.get('/assemble/api/v1/admin/clubs')
        .then((response) => {
          this.clubs = response.data.data;
          this.$store.commit('loading', false);
        }).catch((error) => {
          this.$store.commit('loading', false);
        });
    },
    updateCompPreview(compId) {
      this.previewCompId = compId;
    },
    hasModule(...modules) {
      if (this.clearance === 1) return true;
      const userModules = this.$store.getters['user/module'];
      return modules.every((m) => _.get(userModules, m) === true);
    },
    async fetchEntities() {
      this.$store.commit('loading', true);

      const memberships = await this.$http.get('/assemble/api/v1/admin/memberships');
      this.memberships = memberships.data.data;
      const events = await this.$http.get('/assemble/api/v1/admin/events');
      this.events = events.data.data;

      this.$store.commit('loading', false);
    },
    setSelectedEntity(value) {
      this.form.widgetSettings.calendarEntity.entity = value;
      this.form.widgetSettings.calendarEntity.entityIds = [];
    },
  },
  watch: {
    form: {
      deep: true,
      handler(val) {
        this.showWarning = true;
      }
    },
    entityIds: {
      handler(val) {
        this.form.widgetSettings.calendarEntity.entityIds = [...val.eventIds, ...val.membershipIds];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.app-content-panel {
  padding: 1.5rem 2.5rem !important;
  background-color: red !important;
  box-shadow: $boxShadow;
  border: $border;
  border-radius: $borderRadius;
}
::v-deep .el-upload-list__item-name {
  max-width: 250px;
}

::v-deep .el-form-item__label {
  font-size: 12px;
}

::v-deep .el-radio-group {
  gap: 0 !important;
}

.text-highlight {
  color: $highlight;
}

h1, h2, h3 {
  margin: 0;
}

h3 {
  margin-bottom: 0.5rem;
}

.popper-container {
  display: flex;
  align-items: center;
  justify-content: space-around;
  img {
    cursor: pointer;
  }
  .required-icon {
    font-size: 2rem;
  }
}

.widget-settings-container {
  min-width: 100%;
  display: grid;
  grid-template-columns: 2.5fr 7.5fr;
  gap: 1.5rem;
  padding: 0 1rem;
  padding-bottom: 4.5rem;
  position: relative;
  .editor {
    // margin: 0 auto;
    // background: #FFFFFF;

    // border: 1px solid rgba(96, 98, 102, 0.5);
    // border: 1px solid #eee;
    // box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    // filter: drop-shadow(0px 2px 12px rgba(0, 0, 0, 0.1));
    // border-radius: 12px;
    // margin-right: 2vmin;
    // width: 100%;

    .editor-section {
      width: 100%;
      min-height: 100vh;
      background: white;
      padding: 1.5rem 2rem;
      border: 0.5px solid rgba(45, 58, 69, 0.15);
      box-shadow: 0px 3px 6px rgb(233 233 233 / 50%);
      border-radius: 16px;
      // .widget-preview {
      //   width: 100%;
      //   height: 100%;
      // }
      .widget-preview-container {
        // border: 1px solid #ccc;
        // box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);
        // padding: 20px;
        border-radius:10px;
        display: flex;
        margin: 0 auto;
        margin-top: 20px;
        background: #fff;
        overflow-y:auto;
        overflow-x:hidden;
      }
    }

    .installation-guide-box{
      padding: 20px;
      border-radius:16px;
      // display: flex;
      border: 0.5px solid rgba(45, 58, 69, 0.13);
      box-shadow: 0px 3px 6px rgb(233 233 233 / 50%);
      margin: 0 auto;
      margin-top: 20px;
      padding: 1.5rem 2rem;
      background: #fff;
    }

      .footer {
        text-align: center;
        font-size: 0.875rem;
        line-height: 2.5rem;
        color: #606266;
      }
  }

  .side-menu {
    // padding-right: 2rem;
    // padding-top: 1.5rem;
    // background: #FAFAFA;
    // border: 1px solid #eee;
    // box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    // border-radius: 3px;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;

    .items-wrapper {
      position: sticky;
      top: 2.5%;
      .controllable-box{
        background: #ffffff;
        padding: 1.5rem;
        border: 0.5px solid rgba(45, 58, 69, 0.15);
        box-shadow: 0px 3px 6px rgb(233 233 233 / 50%);
        border-radius: 16px;
        margin-bottom: 1rem;
        .description{
          font-size: 0.875rem;
          // line-height: 1.5rem;
          color: #000;
          opacity: 0.5;
          margin-bottom: 20px;
        }
      }
    }

    .member-count {
      color: #ef6563;
      text-align: right;
    }

    .filter-header {
      font-size: 1.25rem;
      line-height: 2.5rem;
    }
  }
  .action-buttons {
    z-index: 999;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: center;
    margin: 0 -3.15rem;
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    padding: 1rem;
    background: $primary;
    border-top: 1px solid #eee;
    // border-radius: 16px;
    box-shadow: 0px 2px 4px rgba(135, 135, 135, 0.14);

    .find-member-btn {
      &:hover {
        border: 1px solid #000;
        background: none;
      }
    }
  }
}

.intro-panel {
  margin-bottom: 1.5rem;
  padding: 1.5rem 20px;
  background-color: #ffffff;
  box-shadow: $boxShadow;
  border: $border;
  border-radius: $borderRadius;
}
</style>
